import moment from 'moment';
import DateFormats from '@/core/constants/DateFormats';

export function dateFormatWithAmPmDots(date, lowercase = false) {
  if (!date) return '';

  const format = lowercase
    ? DateFormats.DISPLAY_DATETIME_AMPM_LOWER
    : DateFormats.DISPLAY_DATETIME_AMPM;

  const formatted = moment(date).format(format);

  return lowercase
    ? formatted.replace('am', 'a.m.').replace('pm', 'p.m.')
    : formatted.replace('AM', 'A.M.').replace('PM', 'P.M.');
}

// date must include time
// time param is only needed when you have a standalone time without a date
export function toCalendarDateTime(date, time = null) {
  if (!date) return '';

  const dateStr = moment(date).format(DateFormats.ISO_DATE);
  const timeStr = time
    ? time.substr(0, 5)
    : moment(date).format(DateFormats.DISPLAY_TIME);

  return `${dateStr} ${timeStr}`;
}
